import { render, staticRenderFns } from "./LoadGalleryButton.vue?vue&type=template&id=bf2e1bd0&"
import script from "./LoadGalleryButton.vue?vue&type=script&lang=js&"
export * from "./LoadGalleryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports